import { makeVar } from '@apollo/client';

export interface ICourseProviders {
  id: number;
  institutionId: string;
  providerId: string;
}

export interface ICourseProvidersCache {
  error: string;
  data: ICourseProviders[];
  loaded?: boolean;
}

export const emptyCourseProvidersCache: ICourseProvidersCache = {
  error: '',
  data: [],
  loaded: false,
};

export const getCourseProviderIds = (providers: ICourseProviders[]): string[] =>
  providers.map((provider) => provider.providerId).filter(Boolean);

export const getDefaultProvidersId = (providers: ICourseProviders[]): string =>
  getCourseProviderIds(providers).join(',');

export const isCourseProvidersLoaded = (cache: ICourseProvidersCache): boolean =>
  cache.loaded === true || cache.data.length > 0 || Boolean(cache.error);

export const getCourseProvidersState = (
  cache: ICourseProvidersCache,
): { providerIds: string[]; defaultProvidersId: string; loaded: boolean } => {
  const providerIds = getCourseProviderIds(cache.data);

  return {
    providerIds,
    defaultProvidersId: providerIds.join(','),
    loaded: isCourseProvidersLoaded(cache),
  };
};

export const coursesProvidersReactiveVars = makeVar<ICourseProvidersCache>(emptyCourseProvidersCache);
